import React, { memo, useCallback } from "react";

import colors from "app/colors";
import { ViewDetailsIcon } from "modules/icons";
import { MessageFragment } from "gql/graphql";
import CircularIconButton from "../../../_shared/buttons/circular-icon-button";
import SyncoTooltip from "../../../_shared/synco-tooltip";
import {
  MIXPANEL_EVENT_TYPE,
  useMixpanel,
} from "modules/providers/mixpanel-provider/mixpanel-provider";
import { Button, HStack, Text } from "@chakra-ui/react";
import { useOverlay } from "modules/providers/overlay-provider";
import { DRAWER_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  message: MessageFragment;
  displayText?: string;
}

const MessagePopoverMessageInfoButton: React.FC<IProps> = ({
  message,
  displayText,
}) => {
  const { openDrawer } = useOverlay();
  const { track } = useMixpanel();

  const openMessageProfile = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      openDrawer({
        type: DRAWER_TYPE.MESSAGE_PROFILE,
        id: message.id,
        id2: message.messageThreadId,
      });
      track(MIXPANEL_EVENT_TYPE.MESSAGE_DETAILS_VIEWED);
    },
    [openDrawer, message.id, message.messageThreadId, track],
  );

  if (displayText) {
    return (
      <Button variant="link" onClick={openMessageProfile}>
        <HStack spacing={2}>
          <ViewDetailsIcon boxSize={5} fill={colors.blue} />
          <Text fontSize={14} color={colors.blackSecondary}>
            {displayText}
          </Text>
        </HStack>
      </Button>
    );
  }

  return (
    <SyncoTooltip label="Message Info" openDelay={1000} placement="top-end">
      <CircularIconButton
        size="xs"
        aria-label="Message Info"
        icon={<ViewDetailsIcon boxSize={5} fill={colors.blue} />}
        onClick={openMessageProfile}
      />
    </SyncoTooltip>
  );
};

export default memo(MessagePopoverMessageInfoButton);
